import { SKILL_PHASES } from "./constants";

const DEFAULT_PHASE = "generation";

function parseFrontmatter(md) {
  if (!md) return { frontmatter: {}, body: "" };
  const match = md.match(/^---\n([\s\S]*?)\n---\n?([\s\S]*)$/);
  if (!match) return { frontmatter: {}, body: md.trim() };

  const frontmatter = {};
  match[1].split("\n").forEach((line) => {
    const idx = line.indexOf(":");
    if (idx === -1) return;
    const key = line.slice(0, idx).trim();
    const value = line.slice(idx + 1).trim().replace(/^"|"$/g, "");
    if (key) frontmatter[key] = value;
  });

  return { frontmatter, body: match[2].trim() };
}

function stripMarkdownExtension(filename = "") {
  return filename.replace(/\.(md|markdown)$/i, "");
}

function toSkillName(value, fallback = "CustomSkill") {
  const cleaned = stripMarkdownExtension(value || "")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[^a-zA-Z0-9]+/g, " ")
    .trim();

  if (!cleaned) return fallback;

  return cleaned
    .split(/\s+/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join("");
}

function slugifySkillName(name) {
  return (name || "custom_skill")
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "") || "custom_skill";
}

function normalizePhase(phase) {
  return SKILL_PHASES.includes(phase) ? phase : DEFAULT_PHASE;
}

function buildMarkdown({ name, description, phase, body }) {
  return `---\nname: ${name}\ndescription: ${description}\nphase: ${phase}\n---\n\n${(body || "").trim() || "## Instructions\n\nDescribe what this skill should do."}\n`;
}

function buildSkill({ name, description, phase, body, markdown, source }) {
  return {
    id: `sk_custom_${slugifySkillName(name)}`,
    name,
    description,
    phase,
    enabled: true,
    source,
    markdown: markdown || buildMarkdown({ name, description, phase, body }),
    created_at: new Date().toISOString(),
  };
}

export function buildSkillFromMarkdown(markdown, options = {}) {
  const filename = options.filename || "skill.md";
  const { frontmatter, body } = parseFrontmatter(markdown);
  const name = frontmatter.name || toSkillName(filename);
  const description = frontmatter.description || `Custom skill created from ${filename}.`;
  const phase = normalizePhase(frontmatter.phase);
  const hasCompleteFrontmatter = frontmatter.name && frontmatter.description && frontmatter.phase === phase;

  return buildSkill({
    name,
    description,
    phase,
    body,
    source: options.source || "upload",
    markdown: hasCompleteFrontmatter ? markdown : buildMarkdown({ name, description, phase, body }),
  });
}

export function buildSkillFromManualInput(input = {}) {
  const name = toSkillName(input.name, "CustomSkill");
  const description = (input.description || `Custom skill for ${name}.`).trim();
  const phase = normalizePhase(input.phase);

  return buildSkill({
    name,
    description,
    phase,
    body: input.body,
    source: "manual",
  });
}
